window.site_url = window.site_url || "";

export const apiUrl   = window.site_url;

export const siteUrl   = window.site_url;

export const registrationYear = window.registration_year;
